<ng-container *ngIf="paymentMethod; else noPaymentMethod">
  <div class="min-h-dvh w-full max-w-[636px]">
    <div class="flex flex-col w-full h-full"> 
      <section class="px-6">
        <app-sign-in-header [cmsLabels$]="cmsLabels$" [languageList]="languageList" [displayBackButton]="displayBackButton()" (backButtonClickEvent)="handleBackButton()"></app-sign-in-header>
      </section>
      <section class="h-full">
        <div [ngClass]="{'hidden': currentStep !== 0, 'h-full': currentStep === 0}">
          <p>Todo: 0 - Landing page</p>
          <p>{{ paymentMethod$ | async }}</p>
        </div>
        <div [ngClass]="{'hidden': currentStep !== 1, 'h-full': currentStep === 1}">
          <!-- <p>Todo: 1 - Gffp (sendvaldiate)</p> -->
            <app-gffp
              [enumerations]="enumerationsResponse$ | async"
              [countries]="countries$ | async"
              [labels]="(cmsLabels$ | async)?.labels"
              [locale]="locale"
              [fieldNames]="(gffpFieldNames$ | async) || []"
              [sendValResponseError]="sendValResponseError$ | async"
              (submitted)="onGffpSubmit($event)"
            ></app-gffp>
        </div>
        <div [ngClass]="{'hidden': currentStep !== 2, 'h-full': currentStep === 2}">
          <!-- <p>Todo: 2 - summary (commit)</p> -->
          <app-summary
            *ngIf="summaryData$ | async as summaryData"
            [flow]="operation"
            [labels]="(cmsLabels$ | async)?.labels"
            [wallet]="walletProvider"
            [locale]="locale"
            [isWalletFeeEnabled]="isWalletFeeEnabled$ | async"
            [exchangeRate]="exchangeRate"
            [summaryData]="summaryData"
            [stateOptions]="subdivisionOptions"
            [selectedLocation]="selectedLocation$ | async"
            (next)="onCommit()"
          ></app-summary>
        </div>
        <div [ngClass]="{'hidden': currentStep !== 3, 'h-full': currentStep === 3}">
          <p>Todo: 3 - confirmation ("thank you page")</p>
            <!-- <app-confirmation
              *ngIf="summaryData$ | async as summaryData"
              [commitResponse]="commitResponse"
              [labels]="(cmsLabels$ | async)?.labels"
              [walletProvider]="walletProvider"
              [isformFreeLocation]="false"
              [isWalletFeeEnabled]="(isWalletFeeEnabled$ | async)"
              [flow]="operation"
              [google]="google"
              [exchangeRate]="exchangeRate"
              [summaryData]="summaryData"
              [stateOptions]="subdivisionOptions"
              [selectedLocation]="selectedLocation$ | async"
              [locale]="locale"
            ></app-confirmation> -->
        </div>
      </section>
      <!-- Todo: remove: next button -->
      <button (click)="todoNext()">next</button>
    </div>
  </div>
</ng-container>
<ng-template #noPaymentMethod>
  <p>Todo: something has gone wrong, no payment method is selected</p>
</ng-template>